import type { AnnotationLabelT, AnnotationUnderUserReviewMapT } from '../../../../common/types/types';
import { CUSTOM_TOOLS, SAM_ANNOTATION_ACTIONS, TOOL } from '../../constants';
import type { EditorModeT, ToolT } from '../../types';
import { EDITOR_MODE_TYPE } from '../../types';
import { LABEL_TYPE_CONFIG, TOOL_CONFIG } from './constants';
export const getSAM3TextPrompt = (label: AnnotationLabelT): string => label.instanceLabelTitle ?? label.title.replace(/_\d+$/, '');
export const getSAM3LabelAnalyticsPayload = (label: AnnotationLabelT): {
  annotationLabelTitle: string;
  parentLabelTitle: string;
  isInstanceLabel: boolean;
} => {
  const parentLabelTitle = getSAM3TextPrompt(label);
  return {
    annotationLabelTitle: label.title,
    parentLabelTitle,
    isInstanceLabel: !!(label.instanceLabelTitle || label.title.match(/_\d+$/))
  };
};
export const getHotkeys = () => {
  const hotKeys = [];
  Object.keys(TOOL).forEach(tool => {
    // @ts-expect-error missing null check
    hotKeys.push({
      key: TOOL_CONFIG[tool].hotkey.toUpperCase(),
      description: `Select ${TOOL_CONFIG[tool].title} tool`
    });
  });
  return hotKeys;
};
export const isLabelingMode = (editorMode: EditorModeT) => {
  return editorMode === EDITOR_MODE_TYPE.LABELING;
};
export const isIncludePointPresent = (annotationUnderUserReviewMap: AnnotationUnderUserReviewMapT = {}) => {
  const annotationIds = Object.keys(annotationUnderUserReviewMap);
  if (annotationIds.length === 0) return false;
  // @ts-expect-error todo(ts-migration) TS2538 Type 'undefined' cannot be used as an index type.
  const annotationUnderReview = annotationUnderUserReviewMap[annotationIds[0]];
  const type = annotationUnderReview.type;
  if (type !== SAM_ANNOTATION_ACTIONS.POINT) return false;
  const metaDataPoints = annotationUnderReview.annotationMetaData;
  return !!metaDataPoints.find(point => point.type === 'INCLUDE');
};
export const getToolIcon = (annotationType: keyof typeof TOOL_CONFIG | keyof typeof LABEL_TYPE_CONFIG) => {
  if (annotationType in TOOL_CONFIG) {
    return TOOL_CONFIG[(annotationType as ToolT)].Icon;
  }
  return LABEL_TYPE_CONFIG[(annotationType as keyof typeof LABEL_TYPE_CONFIG)].Icon;
};
export const getToolsForLabel = (selectedAnnotationLabel?: AnnotationLabelT | undefined | null) => {
  let tools: string[];
  if (selectedAnnotationLabel?.tools?.some(tool => tool in CUSTOM_TOOLS)) {
    tools = selectedAnnotationLabel?.tools?.filter(tool => !(tool in CUSTOM_TOOLS));
  } else if (selectedAnnotationLabel?.tools && selectedAnnotationLabel.tools.length > 0) {
    tools = selectedAnnotationLabel.tools;
  } else {
    tools = Object.keys(TOOL);
  }
  // Return unique tools only
  return [...new Set(tools)];
};